import React from 'react';

export const Slider = ({ value, onValueChange, min, max, step, className = '' }) => {
  const [minValue, maxValue] = value;

  const handleMinChange = (e) => {
    const newMin = parseInt(e.target.value);
    if (newMin <= maxValue) {
      onValueChange([newMin, maxValue]);
    }
  };

  const handleMaxChange = (e) => {
    const newMax = parseInt(e.target.value);
    if (newMax >= minValue) {
      onValueChange([minValue, newMax]);
    }
  };

  return (
    <div className={`slider-container ${className}`}>
      <div className="slider-track">
        <div 
          className="slider-range" 
          style={{
            left: `${((minValue - min) / (max - min)) * 100}%`,
            right: `${100 - ((maxValue - min) / (max - min)) * 100}%`
          }}
        />
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={minValue}
        onChange={handleMinChange}
        className="slider-input slider-input-min"
      />
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={maxValue}
        onChange={handleMaxChange}
        className="slider-input slider-input-max"
      />
    </div>
  );
};
